(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealTargets = [
    '.drjaytee-house-product-shelf',
    '.drjaytee-house-pathways',
    '.drjaytee-house-trust-access',
    '.drjaytee-review-rail',
    '.drjaytee-house-consultation',
    '.drjaytee-house-clinic',
    '.drjaytee-house-faq',
  ].join(',');

  const elements = Array.from(document.querySelectorAll(revealTargets)).filter((element) => {
    return element instanceof HTMLElement;
  });

  if (!elements.length) return;

  if (motionQuery.matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('drjaytee-scroll-reveal', 'is-visible'));
    return;
  }

  document.documentElement.classList.add('drjaytee-motion-ready');

  const reveal = (element) => {
    element.classList.add('is-visible');
    observer.unobserve(element);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        reveal(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12,
    }
  );

  elements.forEach((element) => {
    element.classList.add('drjaytee-scroll-reveal');
    observer.observe(element);
  });

  window.setTimeout(() => {
    elements.forEach(reveal);
  }, 1200);
})();
